import React, {useEffect, useState} from "react";
import RenderComponent from "./RenderComponent";

export default function LabTwelve(){
    const [data, setData] = useState([]);
    useEffect(() => {
        async function fetchData(){
            const rawData = await fetch("https://collectionapi.metmuseum.org/public/collection/v1/objects/45734");
            const result = await rawData.json();
            setData(result);
        }

        fetchData()
            .then((r) => console.log("Data fetched successfully"))
            .catch((e) => console.log("There was an error"));

    }, []);
    
    return(
        <>
            {
                <RenderComponent
                    key = {data.objectID}
                    title = {data.title}
                    medium = {data.medium}
                    period = {data.period}
                    artistDisplayName = {data.artistDisplayName}
                    accessionYear = {data.accessionYear}
                    department = {data.department}
                    culture = {data.culture}
                    primaryImageSmall = {data.primaryImageSmall}
                />

            }
        </>
    );
}